import { FC } from 'react';

import bootstrapPage, { BootstrapPageProps } from '../HOCs/bootstrapPage';
import MetaHead from '../components/MetaHead';
import Layout from '../components/layouts/Layout';
import privacyHtml from '../components/policies/privacy';

const PrivacyPage: FC<BootstrapPageProps> = () => (
  <>
    <MetaHead
      title="Privacy | Wave.video"
      description="This page explains how we treat information related to your use of this website and the services offered on and through it, including the personal information you provide while using it."
    />

    <Layout navigationVariant="white" mainVariant="contain">
      <div dangerouslySetInnerHTML={{ __html: privacyHtml }} />
    </Layout>
  </>
);

export default bootstrapPage(PrivacyPage);
